import { render } from "./Main.vue?vue&type=template&id=0802b2d4"
import script from "./Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Main.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"desktope/modules/delivery/Main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0802b2d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0802b2d4', __exports__)) {
    api.reload('0802b2d4', __exports__)
  }
  
  module.hot.accept("./Main.vue?vue&type=template&id=0802b2d4", () => {
    api.rerender('0802b2d4', render)
  })

}


export default __exports__